import BusinessUnitEntity from "../entities/BusinessUnitEntity";
import SearchResultEntity from "../entities/SearchResultEntity";

export default interface BusinessUnitRepository {
    search: (word: string, page: number, itemsPerPage: number, filter: any) => Promise<SearchResultEntity<BusinessUnitEntity>>;
}

export const BusinessUnitRepositoryName = "BusinessUnitRepository";